export const employeesTableInventory = [
	{
		settings: true,
		text: "Parent",
		value: "name",
		func: false,
		sortable: true,
		footer: "count",
	},
	{
		settings: true,
		text: "Inventory",
		value: "type",
		func: false,
		sortable: true,
		footer: "count",
	},
	{
		settings: true,
		text: "Series",
		value: "series",
		func: false,
		sortable: true,
	},
	{
		width: '80px',
		settings: true,
		buttons: [
			{
				perm: { or: [ 10, 9 ] },
				value: 'edit',
				text: 'Edit inventory',
				icon: { value: 'edit', w: 18, h: 18 },
			},
			{
				perm: {
					or: [ 11 ]
				},
				value: 'delete',
				text: 'Delete inventory',
				icon: { value: 'deleteItem', w: 18, h: 18 },
			}
		]
	},
];

export const documentsTableInventory = [
	{
		settings: true,
		text: "Type",
		value: "type_name",
		func: false,
		sortable: true,
		footer: "count",
	},
	{
		settings: true,
		text: "Name",
		value: "document_name",
		func: false,
		sortable: true,
		footer: "count",
	},
	{
		width: '80px',
		settings: true,
		buttons: [
			{
				perm: { or: [ 10, 9 ] },
				value: 'eye',
				text: 'View document',
				icon: { value: 'eye', w: 18, h: 18 },
			},
			{
				perm: {
					or: [ 11 ]
				},
				value: 'delete',
				text: 'Delete document',
				icon: { value: 'deleteItem', w: 18, h: 18 },
			}
		]
	},
];
export const documentsTableCustomers = [
	{
		settings: true,
		text: "ID",
		value: "id",
		func: false,
		sortable: true,
	},	{
		settings: true,
		text: "Customer",
		value: "value",
		func: false,
		sortable: true,
		footer: "count",
	},
	{
		width: '80px',
		settings: true,
		buttons: [
			{
				perm: {
					or: [ 11 ]
				},
				value: 'delete',
				text: 'Delete customer',
				icon: { value: 'deleteItem', w: 18, h: 18 },
			}
		]
	},
];
export const documentsTableDispatchers = [
	{
		settings: true,
		text: "ID",
		value: "id",
		func: false,
		sortable: true,
	},	{
		settings: true,
		text: "Dispatcher",
		value: "value",
		func: false,
		sortable: true,
		footer: "count",
	},
	{
		width: '80px',
		settings: true,
		buttons: [
			{
				perm: {
					or: [ 11 ]
				},
				value: 'delete',
				text: 'Delete customer',
				icon: { value: 'deleteItem', w: 18, h: 18 },
			}
		]
	},
];
export const TITLE = {
	REMOVE_INVENTORY: 'Remove inventory',
	REMOVE_EXTENSION: 'Remove extension',
	REMOVE_MESSENGER: 'Remove messenger',
	REMOVE_DOCUMENT: 'Remove document',
};
export const TEXT = {
	REMOVE_INVENTORY: 'Are you sure you want to remove this inventory?',
	REMOVE_EXTENSION: 'Are you sure you want to remove this extension?',
	REMOVE_MESSENGER: 'Are you sure you want to remove this messenger?',
	REMOVE_DOCUMENT: 'Are you sure you want to remove this document?',
};
